import script from "./BetInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BetInput.vue?vue&type=script&setup=true&lang=js"

import "./BetInput.vue?vue&type=style&index=0&id=67a21b6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a21b6b"]])

export default __exports__